export default __webpack_public_path__ + "static/media/busd.cc9ffc73.svg";